export const initialState = {
  trigger: '',
  displayName: '',
  templateText: '',
  roles: [],
};
